import React from 'react';
import PropTypes from 'prop-types';

import settingsReader from '../../store/readHelpers/SettingsReader';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import AdditionalResource from './AdditionalResource';
import constants from '../../qti/Constants';

const RubricAdditionalResource = (props) => {
    const BASE_RUBRICS_URL = '/rubrics?mode=studentMode';

    const { currentlyShownQuestion } = props;

    const { rubricsContentItemId, rubricsContentRevisionId } = currentlyShownQuestion;
    const assessmentRunId = sessionReader.getAssessmentRunId();

    const params = {
        contentItemId: rubricsContentItemId,
        assessmentRunId,
    };

    if (rubricsContentRevisionId) {
        params.contentRevisionId = rubricsContentRevisionId;
    }

    const queryString = new URLSearchParams(params).toString();
    const rubricsUrl = `${BASE_RUBRICS_URL}&${queryString}`;

    let linkText = t('general.rubric');
    if (settingsReader.isShowQuestionTitlesEnabled()) {
        linkText = `${linkText} ${t('general.for')} ${currentlyShownQuestion.title}`;
    }

    return <AdditionalResource url={rubricsUrl} title={linkText} type={constants.additionalResourceType.RUBRIC} />;
};

RubricAdditionalResource.propTypes = {
    currentlyShownQuestion: PropTypes.object.isRequired,
};

export default RubricAdditionalResource;
